<template>
  <div class="stats-graph-main">
    <h1>{{head}}</h1>
    <div>
    <GraphExample :graphData=graphData></GraphExample>
    </div>
  </div>
</template>

<script>
import GraphExample from "../../../../views/GraphExample"

export default {
  props: {
    head: [String],
    graphData: [Array]
  },
  components:{
    GraphExample
  }
};
</script>

<style scoped>
.stats-graph-main {
  box-shadow: 2px 2px 10px #000000;
  border-radius: 10px;
  padding: 10px;
  background-image: radial-gradient(
    ellipse 100% 60% at top,
    #26292e 0.04%,
    #1a1c1f 100%
  );
  /* display: flex;
  flex-direction: column; */
  /* height: 275px; */
  min-height: 350px;
  height: 350px;
  width: 45%;
  
}
.stats-graph-main > div{
  max-height: 90%;
  height: 90%;
  margin-bottom: 20px;
}
.stats-graph-main>h1{
  text-align: center;
}
</style>